// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentId_ACTIONABLE } from "../schema";

export function serialize_ContentId_ACTIONABLE_internal(value: ContentId_ACTIONABLE): unknown {
  return ((value: { contentType: "ACTIONABLE"; id: bigint }): unknown => {
    return {
      contentType: ((value: "ACTIONABLE"): unknown => {
        return value;
      })(value["contentType"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
    };
  })(value);
}
export function serialize_ContentId_ACTIONABLE(obj: ContentId_ACTIONABLE): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentId_ACTIONABLE_internal(obj));
}
export function deserialize_ContentId_ACTIONABLE_internal(value: unknown): ParserResult<ContentId_ACTIONABLE> {
  return ((
    value: unknown,
  ): ParserResult<{
    contentType: "ACTIONABLE";
    id: bigint;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ActionableId]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ActionableId]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "contentType")) {
      return { success: false, reason: `[#/components/schemas/ActionableId/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
    }
    const parsed_contentType = ((): ParserResult<"ACTIONABLE"> => {
      return ((value: unknown): ParserResult<"ACTIONABLE"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ActionableId/contentType]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "ACTIONABLE":
            return { success: true, value: "ACTIONABLE" };
          default:
            return { success: false, reason: `[#/components/schemas/ActionableId/contentType]: '${value}' expected to be enum, one of 'ACTIONABLE'.` };
        }
      })(value["contentType"]);
    })();
    if (!parsed_contentType.success) {
      return { success: false, reason: parsed_contentType.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/ActionableId/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ActionableId/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    return { success: true, value: { contentType: parsed_contentType.value, id: parsed_id.value } };
  })(value);
}
export function deserialize_ContentId_ACTIONABLE(str: string): ParserResult<ContentId_ACTIONABLE> {
  return deserialize_ContentId_ACTIONABLE_internal(parseJsonWithNumbersAsBigint(str));
}
